module.exports = __webpack_public_path__ + "static/media/list_view_icon_blue.f0cc9f15.svg";